/* eslint-disable camelcase */
import React from 'react'
import { Details } from '@nautilusjs/component-core'
import { Box } from '@maui/elements'
import isEmpty from 'lodash/isEmpty'
import { SourcesWidget, MScoreDetails } from '../common'
import { detailsMap } from '../common/IndicatorDetailsMap'
import { HashDetails } from '@horizon-shared/hash-details'
import RelevantReportsDetail from './RelevantReportsDetail'
import { AssociationsDetails } from '@horizon-shared/indicator-details'

export const IndicatorDetails = ({ indicator, hashDetailsVariant, initialTab, ...mscoreProps }) => {
  const {
    attributed_associations: associations,
    mscore,
    reports,
    sources,
    type,
    value,
    verdict,
    campaigns,
  } = indicator || {}

  /**
   * To avoid exporting HashDetails and HashSummary,
   * we are exposing a hashDetailsVariant prop that
   * decides which component to render, in my opinion
   * this is better then exposing multiple components
   * and doing this logic on the consumers side
   *
   */
  if (type?.match('sha1|sha256|md5')) {
    const DetailsComponent = hashDetailsVariant === 'page' ? HashDetails : detailsMap[type]
    return (
      <Box>
        <DetailsComponent indicator={indicator} hash={value} initialTab={initialTab} />
      </Box>
    )
  }

  const DetailsComponent = type && detailsMap[type]

  return (
    <Box>
      {mscore >= 0 && <MScoreDetails score={mscore} verdict={verdict} marginBottom="1rem" skeletonOnly {...mscoreProps} />}

      <DetailsComponent data={indicator} />

      {sources?.length > 0 && <Box marginBottom='32px'><SourcesWidget sources={sources} /></Box>}

      {associations?.length > 0 && (
        <AssociationsDetails
          associations={associations}
          campaigns={campaigns || []}
        />
      )}

      <Details>
        {!isEmpty(reports) &&
          <RelevantReportsDetail list={reports} />
        }
      </Details>

    </Box>
  )
}

export default IndicatorDetails
